import React from "react";
import {
  Box,
  CssBaseline,
  Paper,
  Typography,
  Link,
} from "@mui/material";
import AppBarComponent from "../../components/layout/AppbarComponent";

import docImage1 from "../../assets/image/price.png";
import docImage2 from "../../assets/image/consult.png";

const DocumentPage = () => {
  return (
    <>
      <CssBaseline />
      <AppBarComponent />

      <Box
        sx={{
          height: "calc(100vh - 110px)",
          width: "100vw",
          display: "flex",
          justifyContent: "center",
          alignItems: "flex-start",
          backgroundColor: "#ffffff",
          p: 2,
          pt: 4,
        }}
      >
        <Paper
          elevation={3}
          sx={{
            width: { xs: "95%", sm: "90%", md: "80%" },
            minHeight: "80%",
            borderRadius: 2.5,
            backgroundColor: "#C8EAE6",
            border: "2px solid #000000",
            boxShadow: "0 4px 10px rgba(0,0,0,0.5)",
            p: 3,
          }}
        >
          <Typography
            variant="h5"
            sx={{ mb: 4, textAlign: "center" }}
          >
            Software Standard Documents
          </Typography>

          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 4,
            }}
          >
            {/* Document 1 */}
            <Link
              href="https://drive.google.com/file/d/14fVuOJIqREC7WLe-h0XuTiGlWz9SER0s/view"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{ color: "inherit" }}
            >
              <Box sx={{ textAlign: "center", cursor: "pointer" }}>
                <Box
                  component="img"
                  src={docImage1}
                  alt="Document 1"
                  sx={{
                    width: "100%",
                    height: 750,
                    objectFit: "cover",
                    borderRadius: 2,
                    border: "2px solid #000",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                    mb: 1.5,
                  }}
                />
                <Typography variant="subtitle1" fontWeight="bold">
                  มาตรฐานการประเมินราคาและระยะเวลาในการพัฒนาซอฟต์แวร์ ศซว.ทอ.
                </Typography>
              </Box>
            </Link>

            {/* Document 2 */}
            <Link
              href="https://www.consultant.pdmo.go.th/docs/medium_price_new.pdf"
              target="_blank"
              rel="noopener noreferrer"
              underline="none"
              sx={{ color: "inherit" }}
            >
              <Box sx={{ textAlign: "center", cursor: "pointer" }}>
                <Box
                  component="img"
                  src={docImage2}
                  alt="Document 2"
                  sx={{
                    width: "100%",
                    height: 750,
                    objectFit: "cover",
                    borderRadius: 2,
                    border: "2px solid #000",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
                    mb: 1.5,
                  }}
                />
                <Typography variant="subtitle1" fontWeight="bold">
                  หลักเกณฑ์ราคากลางการจ้างที่ปรึกษา สํานักงานบริหารหนี้สาธารณะ
                </Typography>
              </Box>
            </Link>
          </Box>
        </Paper>
      </Box>
    </>
  );
};

export default DocumentPage;
